module.exports = __webpack_public_path__ + "img/places-x.bb2ea3de.svg";